<template>
    <div class="quiz">
        <div class="fond"></div>
        <div class="logo">
            <router-link to="/">
                <img src="../assets/logo-white.svg"/>
            </router-link>
        </div>
        <div class="score">{{ score }}/3 Punkten</div>
        <div class="content">
            <counter :count="activeQuestion"></counter>

            <question :question="question" :key="activeQuestion" @answered="onAnswered" @abort="progress"/>
        </div>

    </div>
</template>

<script>
    import Generator from './QuestionGenerator';
    import Question from "./Question";
    import Counter from './Counter';

    export default {
        name: 'Quiz',
        components: {Question, Counter},
        data() {
            return {
                questions: null,
                score: 0,
                activeQuestion: 1
            }
        },
        created() {
            this.questions = Generator.getSet();

        },
        computed: {
            question() {
                return this.questions[this.activeQuestion - 1];
            },

        },
        methods: {
            onAnswered(point) {
                this.score += point;
                setTimeout(this.progress, 3000)
            },
            progress() {
                this.activeQuestion++;
                if (this.activeQuestion > 3) {
                    this.$router.push('/result/' + this.score);
                };
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    div.quiz {
        color: white;
        z-index: 1;
    }

    .score {
        position: absolute;
        color: white;
        left: 80px;
        top: 80px;
    }

    .content {
        position: absolute;
        z-index: 1;
        left: 10%;
        top: 275px;
        width: 80%;

    }

    .fond {
        background-color: transparentize(#002438, .1);
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .logo {
        position: absolute;
        width: 370px;
        right: 60px;
        top: 60px;

        img {
            width: 100%;
            height: auto;
        }
    }

    h1, h2 {
        font-size: 50px;
        margin: 0;
    }


    p {
        margin: 0;
    }

    .button {
        background-color: #B71E3F;
        text-align: center;
        display: inline-block;
        color: white;
        padding: 0.5rem 1.5rem;
        text-decoration: none;
        border-radius: 5px;
    }

    .text {
        margin: 1rem 0 2rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Quiz.vue